export default "__VITE_ASSET__DBw2abXa__"